<template>
    <div class="lc-archive panel__container">
        <header class="panel__header">
            <h2 class="panel__title">Channel archive</h2>
        </header>

        <template v-if="job === null">
            <div v-if="archive.isEmpty()" class="panel__header">
                <h2 class="lc-empty panel__title text--muted">There are no jobs in the archive</h2>
            </div>
            <table v-else class="table">
                <thead>
                    <th>Job</th>
                    <th>Archived</th>
                    <th></th>
                </thead>
                <tbody>
                    <tr v-for="job in archive.items" :key="job.id" class="lc-archived-job">
                        <td>{{ job.title }}</td>
                        <td>{{ job.archived_at | formattedDate(format) }}</td>
                        <td>
                            <div class="flex justify-start items-center">
                                <dropdown-menu :ref="`dropdown-${job.id}`" inline-template>
                                    <div class="table__dropdown">
                                        <button @click.prevent="toggle()" class="lc-unarchive button button--outline button--rounded job__button">
                                            <span>In <span class="text--primary">Archive</span></span>
                                            <icon type="chevron-bottom" color="secondary"></icon>
                                        </button>
                                        <ul v-if="$parent.columns.length > 0 && open" class="dropdown-menu" role="menu" :aria-expanded="open">
                                            <li v-for="column in $parent.columns" :key="column.id" class="lc-column dropdown-menu__item">
                                                <a href="#" @click.prevent="$parent.reinstate(job, column.id)" class="dropdown-menu__link">{{ column.name }}</a>
                                            </li>
                                        </ul>
                                    </div>
                                </dropdown-menu>

                                <div v-if="currentUser.is_not_guest" @click.prevent="removeJob(job)" class="icon-button icon-button--large ml-8">
                                    <icon type="trash"></icon>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <infinite-loading v-show="archive.canLoadMore()" @infinite="fetchArchiveJobs"></infinite-loading>
        </template>

        <confirm ref="confirmRemoval" :danger="true" @hidden="job = null">
            <h3 slot="title" class="confirmation__title">Delete job</h3>
            Are you sure you want to remove this job?
            <template slot="message">This action cannot be undone</template>
            <template slot="confirm">Delete</template>
        </confirm>
    </div>
</template>

<script>
/* global app, EventBus */
import { mapState } from 'vuex'
import InfiniteLoading from 'vue-infinite-loading'
import DropdownMenu from '../../Global/DropdownMenu'
import Confirm from '../../Global/Confirm'
import Icon from '../../Global/Icon'

export default {
    data () {
        return {
            format: app.config.LONG_DATE,
            job: null
        }
    },

    methods: {
        reinstate (job, columnId) {
            this.$refs[`dropdown-${job.id}`][0].close()
            this.$store.dispatch('channel/reinstateJob', { jobId: job.id, columnId })
        },

        fetchArchiveJobs ($state) {
            this.$store.dispatch('channel/fetchArchive', this.channel.id).then(() => {
                $state.loaded()
            })
        },

        removeJob (job) {
            this.job = job

            this.$refs.confirmRemoval.show(job.title, () => {
                return this.$store.dispatch('channel/removeJob', job.id).then(() => {
                    EventBus.$emit('newSnackbar', `Job ${job.title} removed`)
                })
            })
        }
    },

    computed: {
        ...mapState('users', {
            currentUser: 'current'
        }),
        ...mapState('channel', ['channel', 'archive', 'columns'])
    },

    components: {
        InfiniteLoading,
        DropdownMenu,
        Icon,
        Confirm
    }
}
</script>
